import {createStore} from 'vuex'
import user from "./modules/user";
import Cookies from "js-cookie";

let currentLocale = "cn";
if (window.location.pathname.indexOf("/en") == 0 || window.location.hostname == "exhibitor.sialchina.com") {
  currentLocale = "en"
}


const store = createStore({
    state: {
        sh_domain: "https://www.sialchina.cn/",
        sz_domain: "https://www.sialshenzhen.com/",
        home_domain: currentLocale =="en" ? "https://www.sialchina.com/" : "https://www.sialchina.cn/",
        online_domain: currentLocale =="en" ? "https://online.sialchina.cn/en/" : "https://www.sialchina.cn/",
        visitor_domain: currentLocale =="en" ? "https://visitor.sialchina.com" : "https://visitor.sialchina.cn",
        qrcode_origin: "https://visitor.sialchina.cn/api/getQrcode?text=",
        domain: process.env.VUE_APP_HOST,
        domain_en: process.env.VUE_APP_EN_HOST,
        api_domain: currentLocale =="en" ? process.env.VUE_APP_API_EN_URL : process.env.VUE_APP_API_URL,
        is_now_expoid: [2, 1],
        is_ended_expoid: [],//已结束的展会
        boothUrl: {
            sh: {
                cn: "https://system.sialchina.cn/api/links?id=2573",
                en: "https://dweb.typeform.com/to/nJVMaQr3",
            },
            sz: {
                cn: "https://system.sialchina.cn/api/links?id=2574",
                en: "https://eventensouth.sialchina.com/2026/customer-zone/participation-record/informations.html",
            },
        }
    },
    modules: {
        user,
    },
    getters: {
        roles: state => state.user.roles,
        token: state => state.user.token,
        routers: state => state.user.routers,
        expo_area_list: state => state.user.expo_area_list,//获取当届展区
        verifyInfo: state => state.user.verifyInfo,
        show_matchmaking: state => state.user.show_matchmaking,
        show_precisematch: state => state.user.show_precisematch,
        show_badges: state => state.user.show_badges,
        show_steak: state => state.user.show_steak,
        show_invite: state => state.user.show_invite,
        show_precisebooth_sh: state => state.user.show_precisebooth_sh,
        show_precisebooth_sz: state => state.user.show_precisebooth_sz,
    },
    mutations: {
    },
})

export default store